import App from '@/models/App'
import orderingOrderDeliveryItem from '@/models/OrderingOrdererOrderDeliveryItem'

export default class OrderingOrdererOrderDelivery extends App {
    static get entity() {
        return 'OrderingOrdererOrderDeliveries'
    }

    static all() {
        return this.query()
            .with('orderingOrderDeliveryItems.orderingOrderItem.orderingItem')
            .get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingOrderId: this.attr(''),
            status: this.attr(''),
            deliveryDate: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            orderingOrderDeliveryItems: this.hasMany(
              orderingOrderDeliveryItem,
              'orderingOrderDeliveryId'
            ),
        }
    }

    static apiConfig = {
        actions: {
            fetch(orderingShipId, orderingOrderId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/deliveries`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            find(orderingShipId, orderingOrderId, orderingOrderDeliveryId) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/deliveries/${orderingOrderDeliveryId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, orderingOrderId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/deliveries`,
                    App.get(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingShipId, orderingOrderId, orderingOrderDeliveryId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/deliveries/${orderingOrderDeliveryId}`,
                    App.patch(params),
                    {
                        params: params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingOrderId, orderingOrderDeliveryId) {
              return this.delete(
                  `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/deliveries/${orderingOrderDeliveryId}`,
                  {
                      params: {},
                      headers: {
                          Authorization: 'Bearer ' + App.apiToken(),
                          'Accept-Language': App.acceptLanguage(),
                      },
                      delete: orderingOrderDeliveryId,
                      baseURL: App.apiURL(),
                  }
              )
          },
        },
    }
}
